module.exports = __webpack_public_path__ + "img/communityCode.a83e357c.png";